import { Request } from 'commons/utils/request'

export const getBankPortalLayout = () => Request.post(Request.urls.bank.layout)
